<template>
  <el-form-item :label="type" :prop="prop">
    <el-popover
      placement="bottom"
      :width="400"
      trigger="click"
      v-model:visible="cityPanelIsShow"
    >
      <template #reference>
        <el-input
          type="text"
          autocomplete="off"
          disableautocomplete
          v-model="currCityName"
          :placeholder="placeholder"
          readonly
        />
      </template>
      <span class="vcp-exit">
        <button @click="closeImm">×</button>
      </span>
      <div class="vue-city-selector">
        <!--城市选择-->

        <div
          class="vcp-panel"
          @mouseleave="MouseLeave"
          @mouseenter="MouseEnter"
        >
          <h5>
            城市选择
            <span class="clear-citypanel" @click="clearCityPanel">清空</span>
          </h5>
          <ul class="vcp-tags">
            <li
              :class="{ 'li-is-active': item == tagKey }"
              v-for="(item, index) in tagsArr"
              :key="index"
              @click="choiceTag(item)"
            >
              {{ item }}
            </li>
          </ul>

          <div class="vcp-list">
            <div
              :class="{ 'is-hot': initial == 'hot' }"
              v-for="(citys, initial) in cityList"
              :key="initial"
              v-show="currTagIncludes(initial)"
            >
              <h6 v-if="initial != 'hot'">{{ initial }}</h6>
              <ul>
                <li
                  v-for="v in citys"
                  @click="choiceCity(v.name)"
                  :title="v.name"
                  :key="v.id"
                >
                  {{ v.name }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </el-popover>
  </el-form-item>
</template>

<script>
import { defineComponent, ref, computed, reactive } from 'vue';
export default defineComponent({
  name: 'CityPicker',
  props: {
    type: String,
    prop: String,
    currCityName: {
      type: String,
      default: '',
      required: true,
    },
    placeholder: {
      type: String,
      default: '',
    },
    // 没有热门城市
    noHot: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const cityList = reactive({
      hot: [
        { id: 1, name: '北京' },
        { id: 2, name: '上海' },
        { id: 3, name: '杭州' },
      ],
      A: [
        { id: 4, name: '鞍山' },
        { id: 5, name: '阿尔山' },
      ],
      B: [
        { id: 6, name: '北京' },
        { id: 7, name: '包头' },
      ],
      C: [
        { id: 8, name: '成都' },
        { id: 9, name: '重庆' },
        { id: 10, name: '长沙' },
        { id: 11, name: '长春' },
        { id: 12, name: '常州' },
      ],
      D: [
        { id: 13, name: '大连' },
        { id: 14, name: '敦煌' },
      ],
      E: [{ id: 15, name: '鄂多尔斯' }],
      F: [
        { id: 16, name: '福州' },
        { id: 17, name: '佛山' },
      ],
      G: [
        { id: 18, name: '广州' },
        { id: 19, name: '贵阳' },
        { id: 20, name: '桂林' },
      ],
      H: [
        { id: 21, name: '杭州' },
        { id: 22, name: '哈尔滨' },
        { id: 23, name: '呼和浩特' },
        { id: 24, name: '邯郸' },
      ],
      J: [{ id: 25, name: '济南' }],
      K: [{ id: 26, name: '昆明' }],
      L: [
        { id: 27, name: '兰州' },
        { id: 28, name: '拉萨' },
      ],
      M: [{ id: 29, name: '牡丹江' }],
      N: [
        { id: 30, name: '南京' },
        { id: 31, name: '宁波' },
      ],
      P: [{ id: 32, name: '攀枝花' }],
      Q: [
        { id: 33, name: '青岛' },
        { id: 34, name: '衢州' },
      ],
      R: [{ id: 35, name: '日照' }],
      S: [
        { id: 36, name: '上海' },
        { id: 37, name: '深圳' },
        { id: 38, name: '石家庄' },
        { id: 39, name: '苏州' },
      ],
      T: [
        { id: 40, name: '太原' },
        { id: 41, name: '天津' },
        { id: 42, name: '台州' },
      ],
      U: [
        { id: 43, name: '武汉' },
        { id: 44, name: '温州' },
        { id: 45, name: '乌鲁木齐' },
      ],
      X: [
        { id: 46, name: '西安' },
        { id: 47, name: '厦门' },
      ],
      Y: [
        { id: 48, name: '玉树' },
        { id: 49, name: '义乌' },
      ],
      Z: [
        { id: 50, name: '郑州' },
        { id: 51, name: '舟山' },
        { id: 52, name: '张家口' },
      ],
    });
    //tags
    const tagsArr = ref(['热门', 'ABCDE', 'FGHJ', 'KLMN', 'PQRST', 'WXYZ']);
    const tagKey = ref('热门');
    const tags = ref({});
    if (props.noHot) {
      tagsArr.value = ['ABCD', 'EFGH', 'JKL', 'MNPQ', 'RSTW', 'XYZ'];
      tagKey.value = 'ABCD';
    }
    tagsArr.value.forEach((item) => {
      if (item === '热门') {
        tags.value[item] = ['hot'];
      } else {
        tags.value[item] = item.split('');
      }
    });
    const currTagIncludes = (ini) => {
      // 列表是否属于当前标签
      return currTag.value.includes(ini);
    };
    const choiceTag = (key) => {
      // 选择标签
      tagKey.value = key;
    };
    //show
    const cityPanelIsShow = ref(false);
    const currTag = computed(function() {
      return tags.value[tagKey.value];
    });
    const clearCityPanel = () => {
      //清空
      context.emit('update:currCityName', '');
    };
    const closeImm = () => {
      // 立即关闭城市面板
      cityPanelIsShow.value = false;
    };
    const endChoice = () => {
      if (!isMouseOver.value) {
        closeImm();
      }
    };
    const choiceCity = (name) => {
      closeImm();
      context.emit('update:currCityName', name);
    };
    //mouse
    const isMouseOver = ref(false);
    const MouseEnter = () => {
      isMouseOver.value = true;
    };
    const MouseLeave = () => {
      isMouseOver.value = false;
    };
    return {
      cityList,
      cityPanelIsShow,
      tagsArr,
      tagKey,
      tags,
      isMouseOver,
      currTag,
      clearCityPanel,
      currTagIncludes,
      choiceTag,
      choiceCity,
      MouseEnter,
      MouseLeave,
      closeImm,
      endChoice,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/assets/css/config.scss';
$defaultColor: #d0000e;
.vcp-exit {
  height: 10px;
  position: relative;
  top: -10px;
  right: -10px;
  margin: 0;
  padding: 0;
  button {
    background-color: transparent;
    border: none;
    float: right;
    cursor: pointer;
    font-size: 20px;
  }
}
.vue-city-selector {
  width: 200px;
  position: relative;
  margin: 0;
  padding: 0;
  font: 12px/1.5 'Microsoft YaHei', tahoma, arial, 'Hiragino Sans GB',
    '\\5b8b\4f53', sans-serif;
  color: #555;

  li {
    list-style-type: none;
  }

  input {
    display: block;
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding-left: 6px;
    outline: none;
    font-size: 14px;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
  }

  .vcp-panel {
    position: relative;
    // z-index: 999999;
    left: 10px;
    padding: 12px 10px 0;
    width: 382px;
    min-height: 150px;
    overflow: hidden;
    background-color: #fff;
    animation: vueCitySelector 0.2s ease-out;
    box-sizing: border-box;

    h5 {
      font-size: 12px;
      padding: 0;
      margin: 0;
      margin-bottom: 5px;
      padding-left: 2px;
      color: #aaa;
      line-height: 1.5;
      font-weight: normal;
      position: relative;

      .clear-citypanel {
        position: absolute;
        width: 30px;
        right: 20px;
        top: 0;
        height: 18px;
        line-height: 18px;
        color: $defaultColor;
        cursor: pointer;
      }
    }

    .vcp-tags {
      overflow: hidden;
      margin: 5px 0;
      padding: 0;

      li {
        box-sizing: border-box;
        width: 60px;
        line-height: 20px;
        display: block;
        float: left;
        background-color: #f2f2f3;
        text-align: center;
        border-left: 1px solid #fff;
        cursor: pointer;

        &:first-child {
          border-left: none;
        }

        &:hover {
          color: $defaultColor;
        }

        &.li-is-active {
          background-color: $defaultColor;
          color: #fff;
        }
      }
    }

    .vcp-list {
      overflow: hidden;
      border-bottom: 10px solid #fff;

      & > div {
        margin: 1px 0 -1px;
        padding: 5px 0;
        line-height: 24px;
        border-bottom: 1px dashed #eee;
        overflow: hidden;
      }

      h6 {
        float: left;
        font-weight: normal;
        color: $defaultColor;
        font-size: 13px;
        width: 30px;
        margin: 0;
        padding: 0;
        padding-left: 5px;
      }

      ul {
        overflow: hidden;
        padding: 0;
        margin: 0;

        li {
          float: left;
          width: 60px;
          padding-left: 4px;
          cursor: pointer;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &:hover {
            background-color: #f2f2f3;
            color: $defaultColor;
          }

          &.is-hot {
            padding-left: 10px;

            ul {
              padding: 0;

              li {
                padding-left: 6px;
              }
            }
          }
        }
      }
    }
  }
}

@keyframes vueCitySelector {
  0% {
    opacity: 0;
    transform: translate(0) scale(0);
  }

  100% {
    opacity: 1;
    transform: translate(0) scale(1);
  }
}
</style>
